import { OnInit, Component, Input } from '@angular/core';
import {
  InvoiceCrediflowDeliveryConnection,
  InvoiceCrediflowDeliveryEdge,
} from 'generated/types';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { CrediflowInvoiceStatusGQL } from './graphql/crediflow-status.query.generated';

enum CrediflowStatus {
  REJECTED = 'rejected',
  ERROR = 'error',
  RECEIVED = 'received',
  IN_QUEUE = 'in_queue',
  SENT = 'sent',
  DELIVERED = 'delivered',
  UNKNOWN = 'unknown',
}

type CrediflowEvent = NonNullable<InvoiceCrediflowDeliveryEdge['node']>;
type CrediflowEdges = Pick<InvoiceCrediflowDeliveryConnection, 'edges'>;

@Component({
  selector: 'app-invoice-crediflow-status',
  templateUrl: './crediflow-status.component.html',
})
export class InvoiceCrediflowStatusComponent implements OnInit {
  @Input() public invoiceId: number | null = null;
  public CrediflowStatus = CrediflowStatus;
  public crediflowStatusTranslations: Record<CrediflowStatus, string> = {
    [CrediflowStatus.REJECTED]: 'Nekad',
    [CrediflowStatus.ERROR]: 'Fel',
    [CrediflowStatus.RECEIVED]: 'Mottagen',
    [CrediflowStatus.IN_QUEUE]: 'I kö',
    [CrediflowStatus.SENT]: 'Skickad',
    [CrediflowStatus.DELIVERED]: 'Levererad',
    [CrediflowStatus.UNKNOWN]: 'Okänt',
  };
  public events: CrediflowEvent[] = [];

  constructor(
    private crediflowInvoiceStatusGQL: CrediflowInvoiceStatusGQL,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    if (!this.invoiceId) {
      return;
    }

    this.crediflowInvoiceStatusGQL
      .fetch({ invoiceId: this.invoiceId })
      .pipe(first())
      .subscribe({
        next: ({ data }) => {
          const crediflowConnection =
            data.company?.invoices?.edges?.[0]?.node?.crediflow;
          this.setCrediflowEvents(crediflowConnection);
        },
        error: error => {
          this.messageService.add({
            severity: 'error',
            summary: 'Fel vid hämtning av e-faktura status',
            detail: error.message,
          });
        },
      });
  }

  private setCrediflowEvents(
    crediflowConnection?: CrediflowEdges | null | undefined
  ): void {
    const events =
      crediflowConnection?.edges
        ?.map(edge => edge?.node)
        ?.filter((event): event is CrediflowEvent => !!event) ?? [];

    this.events = events;
  }
}
